import React, { useEffect, useState } from 'react'
import { Col, Row, Card, Button } from '@themesberg/react-bootstrap'
import { getContact, updateContact } from '../../../../controller/api/common';

import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import { CKEditor } from '@ckeditor/ckeditor5-react'
import { useCookies } from 'react-cookie';

export const ContactEditor = () => {

  const [contact, setContact] = useState("")

  const [cookies] = useCookies(['lottmekong'])

  useEffect(() => {
    const getContactFunc = async () => {
      const _contact = await getContact(cookies.lottmekong)

      if (_contact && _contact.data) {
        setContact(_contact.data.content || "")
      }
    }
    getContactFunc()
  }, [cookies.lottmekong])

  const onUpdatePress = async () => {
    try {
      const resp = await updateContact(cookies.lottmekong, contact)
      if (resp) {
        window.location.reload()
      } else {
        alert('Có lỗi xảy ra')
        return false
      }
    } catch (e) {
      alert('error')
    }
  }

  return (
    <Card border="light" className="shadow-sm">
      <Card.Header>
        <Row className="align-items-center">
          <Col>
            <h5>Thông tin liên hệ</h5>
          </Col>
        </Row>
      </Card.Header>
      <Card.Body>
        <CKEditor
          editor={ClassicEditor}
          config={{
            fontFamily: {
              options: [
                'default',
                'Ubuntu, Arial, sans-serif',
                'Ubuntu Mono, Courier New, Courier, monospace'
              ]
            },
            toolbar: ['bold', 'italic', 'heading', 'bulletedList', 'numberedList', 'fontFamily', 'undo', 'redo']
          }}
          data={contact}
          onReady={editor => {
            // You can store the "editor" and use when it is needed.
            console.log('Editor is ready to use!', editor);
          }}
          onChange={(event, editor) => {
            const data = editor.getData();
            setContact(data)
            console.log({ event, editor, data });
          }}
          onBlur={(event, editor) => {
            console.log('Blur.', editor);
          }}
          onFocus={(event, editor) => {
            console.log('Focus.', editor);
          }}
        />
      </Card.Body>
      <Card.Footer>
        <Button onClick={onUpdatePress}>Lưu</Button>
      </Card.Footer>
    </Card>
  );
};